var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveImageCreationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75C3.3375 15.75 2.9845 15.6033 2.691 15.3098C2.3975 15.0162 2.2505 14.663 2.25 14.25V3.75C2.25 3.3375 2.397 2.9845 2.691 2.691C2.985 2.3975 3.338 2.2505 3.75 2.25H14.25C14.6625 2.25 15.0157 2.397 15.3098 2.691C15.6038 2.985 15.7505 3.338 15.75 3.75V14.25C15.75 14.6625 15.6033 15.0157 15.3098 15.3098C15.0162 15.6038 14.663 15.7505 14.25 15.75H3.75ZM3.75 14.25H14.25V4.09091L3.75 3.75V14.25ZM4.5 12.75H13.5L10.6875 9L8.4375 12L6.75 9.75L4.5 12.75Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveImageCreationIcon);
export default __webpack_public_path__ + "static/media/active-image-creation-icon.cfca7002b94edb3dc474a41a85270331.svg";
export { ForwardRef as ReactComponent };